
import Vue from 'vue';
import { ModalTitle, ModalActions, Button, Icon } from '@descomplica/vue-components';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { getCourseCategory } from '@/helpers/category';
import { CourseModel } from '@descomplica/dex-models';
import { downloadImageFromUrl } from '@/helpers/download';
import { ENDPOINTS } from '@/settings/endpoints';

export default Vue.extend({
  components: {
    ModalTitle,
    ModalActions,
    Button,
    Icon,
  },
  props: {
    sharedSuccessfully: {
      type: Boolean,
      default: true,
    },
    imageUrl: {
      type: String,
      default: '',
      required: true,
    },
    disciplineName: {
      required: true,
      type: String,
    },
    course: {
      required: true,
      type: Object as Vue.PropType<CourseModel>,
    },
  },
  data() {
    return {
      downloadingImage: false,
    };
  },
  created() {
    Analytics.trackEvent(EVENT_LABELS.modalViewed, {
      course: this.course.name,
      category: getCourseCategory(this.course),
      postgrad_microcertificate_shared_in_linkedin_modal: true,
      shared_successfully: this.sharedSuccessfully,
    });
  },
  methods: {
    async downloadFile(): Promise<void> {
      if (!this.downloadingImage) {
        this.downloadingImage = true;

        this.trackButtonInteraction('download_image');

        await downloadImageFromUrl({
          imageUrl: this.imageUrl,
          fileName: `Microcertificado - ${this.disciplineName}`,
        });

        this.downloadingImage = false;
      }
    },
    closeModal() {
      this.trackButtonInteraction('close');
      this.$emit('close');
    },
    openLinkedin() {
      this.trackButtonInteraction('open_linkedin');
      window.open(ENDPOINTS.linkedin, '_blank');
    },
    trackButtonInteraction(buttonType: 'download_image' | 'close' | 'open_linkedin'): void {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        postgrad_microcertificate_shared_in_linkedin_modal: true,
        postgrad_microcertificate_shared_in_linkedin_modal_action: buttonType,
        course: this.course.name,
        shared_successfully: this.sharedSuccessfully,
        category: getCourseCategory(this.course),
      });
    },
  },
});
